module.exports = __webpack_public_path__ + "img/c6b63ca.gif";